import { render, staticRenderFns } from "./faultrepaireddetails.vue?vue&type=template&id=2bd437f7&scoped=true"
import script from "./faultrepaireddetails.vue?vue&type=script&lang=js"
export * from "./faultrepaireddetails.vue?vue&type=script&lang=js"
import style0 from "./faultrepaireddetails.vue?vue&type=style&index=0&id=2bd437f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd437f7",
  null
  
)

export default component.exports